// Custom header
$(document).ready(function () {

  function resetMegaMenu($grid) {
    $grid.removeClass('show-submenu submenu-active');
    $grid.find('.main-card')
      .show()
      .removeClass('active-main');

    $grid.find('.submenu-card')
      .hide()
      .removeClass('active-submenu');

    $grid.find('.subcard_indicator').hide();
    $grid.closest('.mega-content')
      .find('.back_to_collection')
      .hide();
  }

  $('.mega-products-grid').each(function () {
    $(this).find('.main-card').show();
    $(this).find('.submenu-card').hide();
  });

  $('.mega-sidebar-item').on('click', function () {
    let tab = $(this).data('child');
    $('.mega-sidebar-item').removeClass('active');
    $(this).addClass('active');

    $('.mega-tab-content').removeClass('active');
    let $activeTab = $('.mega-tab-content[data-tab="' + tab + '"]');
    $activeTab.addClass('active');

    let $grid = $activeTab.find('.mega-products-grid');
    resetMegaMenu($grid);
  });


  $(document).on('click', '.main-card.has-submenu', function (e) {
    e.preventDefault();
    let $card = $(this);
    let $grid = $card.closest('.mega-products-grid');

    let parentTitle = $card.data('title');
    $grid.find('.main-card').hide();
    $grid.find('.submenu-card').hide();

    $card
      .show()
      .addClass('active-main');

    $grid.find('.submenu-card[data-parent="' + parentTitle + '"]')
      .show()
      .addClass('active-submenu');

    $grid.find('.subcard_indicator').show();

    $grid.closest('.mega-content')
      .find('.back_to_collection')
      .show();
  });


  $(document).on('click', '.main-card:not(.has-submenu)', function () {
    let link = $(this).data('link');
    if (link && link !== '#') {
      window.location.href = link;
    }
  });

  $(document).on('click', '.back_to_collection', function () {
    let $content = $(this).closest('.mega-content');
    let $grid = $content.find('.mega-products-grid');
    resetMegaMenu($grid);
  });

  $('.custom-header .hamburger-icon').on('click', function () {

    $('.custom-header .header-navigation')
      .addClass('mobile-menu-active');

    $('.hamburger-icon').hide();
    $('.cross-icon').show();    
    $('.nav-item').find('.mega-menu-wrapper').addClass('mobile-force-show');
  });

  $('.cross-icon').on('click', function () {
    $('.custom-header .header-navigation')
      .removeClass('mobile-menu-active');
     $('.nav-item').find('.mega-menu-wrapper').removeClass('mobile-force-show');

    $('.cross-icon').hide();
    $('.hamburger-icon').show();

    $('.parent-link').each(function () {
      var originalHref = $(this).data('original-href');
      if (originalHref) {
        $(this).attr('href', originalHref);
      }
    });

    // Reset mega menus
    $('.mega-products-grid').each(function () {
      resetMegaMenu($(this));
    });
  });
});
// Custom header


// Subscribe & Save Filter
document.addEventListener('change', function (e) {
  if (e.target.matches('.SubscriptionFilter')) {
    if (e.target.checked) {
      sessionStorage.setItem(
        'previousCollectionUrl',
        window.location.pathname
      );
      window.location.href = '/collections/subscribe-save';
    } else {
      const previousUrl = sessionStorage.getItem('previousCollectionUrl');

      if (previousUrl) {
        window.location.href = previousUrl;
      }
    }
  }
});
// Subscribe & Save Filter

// Signin form
var interval = setInterval(function () {
  var $form = $(".customLoginForm");
  if ($form.length) {
    $form.prepend(`
      <h2>Welcome back <br> Sign in to Rio Health</h2>
      <p>Access your orders, rewards, and faster checkout</p>
    `);
    clearInterval(interval);
  }
}, 500);
// Signin form




// ========================
document.addEventListener('DOMContentLoaded', function () {

  // Run only on homepage
  if (window.location.pathname !== '/') {
    return;
  }

  function initTrustSliders() {
    const wrappers = document.querySelectorAll('.trust-wrapper');

    wrappers.forEach((wrapper) => {

      const items = wrapper.querySelectorAll('.trust-bar__item');
      if (!items.length) return;

      // destroy existing swiper if re-init
      if (wrapper.swiper) {
        wrapper.swiper.destroy(true, true);
        wrapper.swiper = null;
      }

      // only mobile
      if (window.innerWidth > 880) return;

      // avoid re-building DOM multiple times
      if (!wrapper.classList.contains('swiper-ready')) {

        const swiperWrapper = document.createElement('div');
        swiperWrapper.className = 'swiper-wrapper';

        items.forEach(item => {
          item.classList.add('swiper-slide');
          swiperWrapper.appendChild(item);
        });

        wrapper.innerHTML = '';
        wrapper.appendChild(swiperWrapper);

        wrapper.classList.add('swiper', 'swiper-ready');
      }

      const swiper = new Swiper(wrapper, {
        slidesPerView: 'auto',
        spaceBetween: 30,
        loop: true,
        speed: 4000,
        autoplay: {
          delay: 0,
          disableOnInteraction: false,
        },
      });

      wrapper.swiper = swiper;
    });
  }

  initTrustSliders();

  window.addEventListener('resize', function () {
    clearTimeout(window._trustResize);
    window._trustResize = setTimeout(initTrustSliders, 200);
  });

});


document.addEventListener('DOMContentLoaded', function () {
  const gridBtn  = document.getElementById('rh-grid-btn');
  const listBtn  = document.getElementById('rh-list-btn');
  const gridView = document.querySelector('ul.rh-grid-view');
  const listView = document.getElementById('rh-list-view');
  const loadMore = document.querySelector('.load-more-grid-only');

  if (!gridBtn || !listBtn || !gridView || !listView) return;

  function updateLoadMoreVisibility() {
    if (!loadMore) return;

    const isListVisible = window.getComputedStyle(listView).display !== 'none';
    loadMore.style.display = isListVisible ? 'none' : 'block';
  }

  const savedView = localStorage.getItem('rh-view-pref') || 'grid';
  if (savedView === 'list') {
    switchToList(false);
  } else {
    switchToGrid(false);
  }

  updateLoadMoreVisibility();

  gridBtn.addEventListener('click', () => {
    switchToGrid(true);
    updateLoadMoreVisibility();
  });

  listBtn.addEventListener('click', () => {
    switchToList(true);
    updateLoadMoreVisibility();
  });

  function switchToGrid(save) {
    gridView.classList.remove('rh-hidden');
    listView.style.display = 'none';
    gridBtn.classList.add('active');
    listBtn.classList.remove('active');
    if (save) localStorage.setItem('rh-view-pref', 'grid');
  }

  function switchToList(save) {
    gridView.classList.add('rh-hidden');
    listView.style.display = '';
    listBtn.classList.add('active');
    gridBtn.classList.remove('active');
    if (save) localStorage.setItem('rh-view-pref', 'list');
  }

  document.querySelectorAll('.rh-qty-plus').forEach(btn => {
    btn.addEventListener('click', function () {
      const input = this.parentElement.querySelector('.rh-qty-input');
      input.value = parseInt(input.value || 1) + 1;
    });
  });

  document.querySelectorAll('.rh-qty-minus').forEach(btn => {
    btn.addEventListener('click', function () {
      const input = this.parentElement.querySelector('.rh-qty-input');
      const val = parseInt(input.value || 1);
      if (val > 1) input.value = val - 1;
    });
  });

  document.querySelectorAll('.rh-add-btn:not(.rh-add-btn--disabled)').forEach(btn => {
    btn.addEventListener('click', async function () {
      const variantId = this.dataset.variantId;
      const row = this.closest('tr');
      const qtyInput = row ? row.querySelector('.rh-qty-input') : null;
      const qty = qtyInput ? Math.max(1, parseInt(qtyInput.value) || 1) : 1;
      const original = this.textContent;

      this.textContent = 'Adding...';
      this.disabled = true;

      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: parseInt(variantId), quantity: qty })
        });

        if (res.ok) {
          this.textContent = '✓ Added';
          this.classList.add('rh-add-btn--success');

          const cartRes = await fetch('/cart.js');
          const cartData = await cartRes.json();
          document.querySelectorAll('.cart-count-bubble span, [data-cart-count]').forEach(el => {
            el.textContent = cartData.item_count;
          });

          document.dispatchEvent(new CustomEvent('cart:refresh'));

          setTimeout(() => {
            this.textContent = original;
            this.disabled = false;
            this.classList.remove('rh-add-btn--success');
          }, 2000);
        } else {
          const err = await res.json();
          this.textContent = err.description || 'Error';
          setTimeout(() => {
            this.textContent = original;
            this.disabled = false;
          }, 2500);
        }
      } catch (e) {
        this.textContent = 'Error';
        setTimeout(() => {
          this.textContent = original;
          this.disabled = false;
        }, 2500);
      }
    });
  });
});


// sticky bar js //
document.addEventListener('DOMContentLoaded', function () {

  const header = document.querySelector('.custom-header');
  if (!header) return;

  window.addEventListener('scroll', function () {
    if (window.scrollY > 10) {
      header.classList.add('is-sticky');
    } else {
      header.classList.remove('is-sticky');
    }
  });

});

// collection load more js 

$(document).ready(function () {

  $(document).on('click', '#load-more-btn', function (e) {
    e.preventDefault();

    var $btn = $(this);
    var nextUrl = $btn.data('next-url');
    if (!nextUrl) return;

    $btn.prop('disabled', true).text('Loading...');

    $.ajax({
      url: nextUrl,
      method: 'GET',
      dataType: 'html'
    })
    .done(function (responseHtml) {

      var $responseDoc = $('<div>').html(responseHtml);
      var $newItems = $responseDoc.find('#product-grid > li.collection-list-tags');

      if ($newItems.length === 0) {
        $btn.prop('disabled', false).text('Load More Products');
        return;
      }

      $('#product-grid').append($newItems);

      var $newLoadMoreBtn = $responseDoc.find('#load-more-btn');
      if ($newLoadMoreBtn.length) {
        $btn.data('next-url', $newLoadMoreBtn.data('next-url'));
        $btn.prop('disabled', false).text('Load More Products');
      } else {
        $btn.closest('.load-more-container').remove();
      }

      // Re-init Yotpo reviews — only for widgets Yotpo hasn't processed yet
      setTimeout(function () {
        if (window.yotpoWidgetsContainer && typeof yotpoWidgetsContainer.initWidgets === 'function') {
          yotpoWidgetsContainer.initWidgets();
        }
      }, 100);

      $(document).trigger('rh:products-appended', [$newItems]);

    })
    .fail(function () {
      $btn.prop('disabled', false).text('Load More Products');
    });

  });

});

jQuery(function ($) {

  function addLoadingOverlay($scope) {
    $scope
      .find('.custom-featured-collection__info')
      .not('.rh-overlay-added')
      .each(function () {
        $(this)
          .prepend('<div class="loading-overlay gradient"></div>')
          .addClass('rh-overlay-added');
      });
  }

 
  addLoadingOverlay($(document));


  var grid = document.getElementById('product-grid');

  if (grid) {
    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        $(mutation.addedNodes).each(function () {
          if (this.nodeType === 1) {
            addLoadingOverlay($(this));
          }
        });
      });
    });

    observer.observe(grid, { childList: true, subtree: true });
  }

  
});


// for remove the per day price //
document.querySelectorAll('.custom-featured-collection__price').forEach(price => {
    [...price.childNodes].forEach(node => {
        if (node.nodeType === Node.TEXT_NODE) {
            node.remove();
        }
    });
});




document.addEventListener('change', function (e) {
  const input = e.target.closest('.bsub-widget__group input[type="radio"]');
  if (!input) return;

  document.querySelectorAll('.bsub-widget__group').forEach(group => {
    group.classList.remove('is-active');
  });

  const currentGroup = input.closest('.bsub-widget__group');
  if (currentGroup && input.checked) {
    currentGroup.classList.add('is-active');
  }
});


  document.addEventListener('DOMContentLoaded', function () {
    const modal = document.getElementById('ProductModal-{{ section.id }}');
    if (!modal) return;

    const thumbnails = modal.querySelectorAll('.product-media-modal__thumbnail-item');
    const slides = modal.querySelectorAll('.product-media-modal__content > *');
    const prevBtn = modal.querySelector('.product-media-modal__buttons .slider-button--prev');
    const nextBtn = modal.querySelector('.product-media-modal__buttons .slider-button--next');
    const currentCounter = modal.querySelector('.modal-counter--current');

    let currentIndex = 0;

    function updateModalGallery(index) {
      if (!slides.length) return;
      if (index < 0) index = slides.length - 1;
      if (index >= slides.length) index = 0;

      currentIndex = index;

      slides.forEach((slide, i) => {
        slide.style.display = i === currentIndex ? 'flex' : 'none';
      });

      thumbnails.forEach((thumb, i) => {
        thumb.classList.toggle('is-active', i === currentIndex);
      });

      if (currentCounter) {
        currentCounter.textContent = currentIndex + 1;
      }
    }

    thumbnails.forEach((thumb, index) => {
      thumb.addEventListener('click', function () {
        updateModalGallery(index);
      });
    });

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        updateModalGallery(currentIndex - 1);
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        updateModalGallery(currentIndex + 1);
      });
    }

    updateModalGallery(0);
  });


  // for add to button cart for mobile //
 (function ($) {
    "use strict";

    // Only run on mobile
    if ($(window).width() > 767) {
        return;
    }

    var $mainSection = $(".product-details .product__info-container");

    if (!$mainSection.length) {
        $mainSection = $(".product-details");
    }

    var $form = $("#product-form-template--24916056047992__main");
    var $originalButton = $("#ProductSubmitButton-template--24916056047992__main");

    if (!$mainSection.length || !$originalButton.length || !$form.length) {
        return;
    }

    var $stickyWrap = $('<div class="sticky-atc-wrap"></div>');
    var $stickyButton = $originalButton.clone().removeAttr("id");

    $stickyWrap.append($stickyButton);
    $("body").append($stickyWrap);

    $stickyButton.on("click", function (e) {
        e.preventDefault();
        $originalButton.trigger("click");
    });

    var sectionBottom = 0;

    function measure() {
        sectionBottom = $mainSection.offset().top + $mainSection.outerHeight();
    }

    function onScroll() {

        // Hide on desktop if resized
        if ($(window).width() > 767) {
            $stickyWrap.removeClass("is-visible");
            return;
        }

        if ($(window).scrollTop() > sectionBottom - 60) {
            $stickyWrap.addClass("is-visible");
        } else {
            $stickyWrap.removeClass("is-visible");
        }
    }

    measure();
    onScroll();

    $(window).on("scroll", onScroll);

    $(window).on("resize load", function () {
        measure();
        onScroll();
    });

})(jQuery);




// ===========================
const loginObserver = new MutationObserver(function () {
  document.querySelectorAll(".gotoLoginForm, .createAccount .link-button").forEach(function (btn) {
    if (!btn.querySelector("span")) {
      btn.innerHTML = btn.innerHTML
        .replace("Signup", "<span>Signup</span>")
        .replace("Log in", "<span>Log in</span>");
    }
  });
});

loginObserver.observe(document.body, {
  childList: true,
  subtree: true
});
